import { render, staticRenderFns } from "./kitDetail.vue?vue&type=template&id=a1a4d0d2&scoped=true"
import script from "./kitDetail.vue?vue&type=script&lang=js"
export * from "./kitDetail.vue?vue&type=script&lang=js"
import style0 from "./kitDetail.vue?vue&type=style&index=0&id=a1a4d0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a4d0d2",
  null
  
)

export default component.exports